import { Component, EventEmitter, inject, Input, OnChanges, Output } from '@angular/core';
import { Status } from '../../../../globalTypes/base.types';
import { ButtonComponent } from '../../component/layout/element/button.component';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { Fulfillment } from '../../../../globalTypes/fulfillment.types';
import { RefundPublic } from '../../../../globalTypes/refund.types';
import { MatDialog } from '@angular/material/dialog';
import { FaultyClaimDialogComponent, FaultyClaimResponse } from './faulty-claim.response.dialog';
import { lastValueFrom, take } from 'rxjs';

export interface RefundDetailsFaultyClaimResponse {
  refund: RefundPublic,
  accepted: boolean,
  messageToBuyer?: string
}

@Component({
  selector: 'msh-refund-details',
  imports: [ButtonComponent, CurrencyPipe, DatePipe, CommonModule],
  template: `
  @if(fulfillment.refunds_on_fulfillment && fulfillment.refunds_on_fulfillment.length){
    @for(refund of fulfillment.refunds_on_fulfillment; track refund.id){
      <div class="flex justify-between items-center gap-2 bg-copy/10 p-4 px-6 rounded mt-4">
        <div class="flex flex-col items-start gap-2">
          <div class="flex items-center gap-2">
            <div>Refund #{{refund.refundNumber}}</div>
            <div class="text-sm text-orange-400">{{!!fulfillmentStatusMap[refund.statusId] ? fulfillmentStatusMap[refund.statusId].description : refund.statusId}}</div>
            <!-- @if(refund.refundedAt){

            } -->
            <div class="text-xs font-thin">{{refund.amount | currency}}</div>
          </div>
          <div class="flex gap-2">
            @for(parcel of fulfillment.parcels_on_fulfillment; track parcel.id){
              @for(orderItem of parcel.orderItems_on_parcel; track orderItem.id){
                @if(refund.id === orderItem.refundId){
                  <div class="flex flex-col items-start gap-1">
                    <div class=" w-16 h-16 mr-6 rounded bg-white flex items-center justify-center overflow-hidden msh-item-image">
                      <!-- TODO: HANDLE image === null -->
                      @if(orderItem.listingVariation.image){
                        <img 
                          [src]="orderItem.listingVariation.image.url"
                        />
                      }
                    </div>
                    <div class="text-sm">{{orderItem.listingVariation.listing.name}} x {{orderItem.quantity}}</div>
                  </div>
                }
              }
            }
            <div>
              @for(interaction of refund.interactions_on_refund; track interaction.id){
                @if(interaction.isInitial){
                  <div class="text-xs font-thin mb-3">
                                        <div class="">{{
                        interaction.buyerInitiated ? "Buyer" : "Seller"
                      }}: <span class=" font-normal"> {{interaction.subject}}</span>@if(interaction.createdAt){<span class=" opacity-50"> - {{interaction.createdAt | date:'short'}} </span> }</div>
                      <div class="ml-10">{{interaction.body}}</div>
                  </div>
                }
              }
            </div>
          </div>
        </div>

        <div class="flex flex-col items-end gap-2">
          @if(refund.trackingUrl && refund.statusId === 'refund_processing'){
            <div class="min-w-[260px] text-right">
              Return Tracking: <br /> #<a href="{{refund.trackingUrl}}" target="_blank" class="text-sm text-orange-400">{{refund.trackingNumber}}</a></div>
            @if(sellerView){
              @if(!refund.sellerReceivedReturn){
                @if(refund.claimedToBeFaulty && !refund.acceptedAsFaulty && !refund.rejectedAsFaulty){
                  <div>
                    <msh-button cta="Response Required" (click)="openFaultyClaimDialog(refund)"></msh-button>
                  </div>
                }@else {
                  <div>
                    <msh-button cta="Mark as Received" [isLoading]="loading" (click)="markRefundAsReceived.emit(refund)"></msh-button>
                  </div>
                }
              }@else if(refund.statusId === 'refund_processing'){
                <div>Refund is being processed. Admin will handle the next steps.</div>
              }
            }@else{
              <div >
                <a [href]="refund.labelUrl" target="_blank" class="block border rounded p-4 border-green text-green-500 font-bold">Download Shipping Label</a>
              </div>
            }
          }
        </div>
      </div>
    }
}
  `,
  styles: ``,
})
export class RefundDetails implements OnChanges {
  @Input() sellerView = false;
  @Input() loading = false;
  @Input() fulfillmentStatusMap: {[statusId: string]: Status} = {}
  @Input() fulfillment!: Fulfillment;
  @Output() markRefundAsReceived: EventEmitter<RefundPublic> = new EventEmitter<RefundPublic>();
  @Output() respondToFaultyClaim: EventEmitter<RefundDetailsFaultyClaimResponse> = new EventEmitter<RefundDetailsFaultyClaimResponse>();
  @Output() printReturnLabel: EventEmitter<RefundPublic> = new EventEmitter<RefundPublic>();
  dialog = inject(MatDialog);
  ngOnChanges(){
    console.log("Refund details received new fulfillment: ", this.fulfillment)  
  }
  async openFaultyClaimDialog(refund: RefundPublic){
    const result: FaultyClaimResponse = await lastValueFrom( this.dialog.open(FaultyClaimDialogComponent, {
      data: { refund }
    }).afterClosed().pipe(take(1)))
    if(result && result.response === 'accept'){
      this.respondToFaultyClaim.emit({refund, accepted: true, messageToBuyer: result.messageToBuyer})
    }else if(result && result.response === 'reject'){
      this.respondToFaultyClaim.emit({refund, accepted: false, messageToBuyer: result.messageToBuyer})
    }
  }
}
